import React from 'react';
import { 
  Fingerprint, 
  Database, 
  Rocket 
} from 'lucide-react';
import '../css/SectionFour.css'

interface StepData {
  number: string;
  icon: React.ReactNode;
  title: string;
  description: React.ReactNode;
}

const SectionFour: React.FC = () => {
  const steps: StepData[] = [
    {
      number: '1',
      icon: <Fingerprint size={80} color="#72d6ff" strokeWidth={1} />,
      title: 'Learning',
      description: <span>Crikey<sup>ai</sup> instantly interprets complex insurance data, policies, and historical claims - identifying what's relevant, what's missing, and what needs attention in real time.</span>
    },
    {
      number: '2',
      icon: <Database size={80} color="#72d6ff" strokeWidth={1} />,
      title: 'Adapting',
      description: 'It applies insurer-specific logic, compliance rules, and risk frameworks to each case - autonomously deciding, flagging, or escalating based on learned expertise.'
    },
    {
      number: '3',
      icon: <Rocket size={80} color="#72d6ff" strokeWidth={1} />,
      title: 'Delivering',
      description: 'Claims are processed, settled, and reported automatically - creating full transparency for claims agents and customers while continuously improving accuracy and speed.'
    }
  ];

  return (
    <>
      <div className="section-four-container">
        {/* Background particles */}
        <div className="bg-particles">
          {[...Array(25)].map((_, i) => (
            <div
              key={i}
              className="particle-dot"
              style={{
                width: `${Math.random() * 12 + 4}px`,
                height: `${Math.random() * 12 + 4}px`,
                top: `${Math.random() * 100}%`,
                left: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 25}s`,
                animationDuration: `${20 + Math.random() * 15}s`,
              }}
            />
          ))}
        </div>

        {/* Wave pattern */}
        <svg className="wave-pattern" viewBox="0 0 1000 1000" preserveAspectRatio="none">
          <path d="M0,200 Q250,150 500,200 T1000,200" stroke="#72d6ff" strokeWidth="2" fill="none"/>
          <path d="M0,350 Q250,300 500,350 T1000,350" stroke="#72d6ff" strokeWidth="2" fill="none"/>
          <path d="M0,500 Q250,450 500,500 T1000,500" stroke="#72d6ff" strokeWidth="2" fill="none"/>
          <path d="M0,650 Q250,600 500,650 T1000,650" stroke="#72d6ff" strokeWidth="2" fill="none"/>
          <path d="M0,800 Q250,750 500,800 T1000,800" stroke="#72d6ff" strokeWidth="2" fill="none"/>
        </svg>

        {/* Glow spheres */}
        <div className="glow-sphere glow-sphere-1" />
        <div className="glow-sphere glow-sphere-2" />

        <div className="content-wrapper-four">
          {/* Header */}
          <div className="section-four-header">
            <h2 className="section-four-title">How it works:</h2>
            <p className="section-four-subtitle">
              Zero – touch, fraud-aware, fully accountable
            </p>
          </div>

          {/* Steps Grid */}
          <div className="steps-grid">
            {steps.map((step, index) => (
              <div key={index} className="step-card">
                <div className="step-number">{step.number}</div>
                <div className="step-icon">{step.icon}</div>
                <h3 className="step-title">{step.title}</h3>
                <p className="step-description">{step.description}</p>
              </div>
            ))}
          </div>
        </div>
              </div>
      
      <div className='divider-container'>
          <h2 className='divider-text'>Proven outcomes - for Insurers, Your Teams and your Customers</h2>
      </div>
    </>
  );
};

export default SectionFour;